import './PhasingTree.css'

import { Col, Glyphicon, Grid, Label, Row, Table } from 'react-bootstrap'
import React, { Component } from 'react'
import {
  downloadPhasingFilesByPhasingAttachmentId,
  getDownloadFilesByPhasingStepIdURL,
  getElectronViewer,
  getPhasingFilesByPhasingProgramAttachmentIdAsImage,
} from '../../../../api/ispyb.js'

import ImageZoom from 'react-medium-image-zoom'
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js'
import filter from 'lodash/filter'
import find from 'lodash/find'

export default class PhasingTree extends Component {
  getDataFromStep = item => {
    const { PhasingStep_phasingStepType } = item
    var images = []
    var imagesAttachedToPreviousStep = []
    var electronViewer = null
    var metadata = {
      Method: item.PhasingStep_method,
      Step: item.PhasingStep_phasingStepType,
      Program: item.PhasingProgramRun_phasingPrograms,
      stepId: item.PhasingStep_phasingStepId,
      spaceGroup: item.SpaceGroup_spaceGroupShortName,
    }

    if (PhasingStep_phasingStepType.toUpperCase() === 'PREPARE') {
      metadata['Resolution (high/low)'] = item.PhasingStep_highRes + ' - ' + item.PhasingStep_lowRes

      images.push({
        url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
          this.props.user,
          this.props.proposal,
          item.phasingProgramAttachmentId
        ),
        caption: '',
      })
    }

    if (PhasingStep_phasingStepType.toUpperCase() === 'SUBSTRUCTUREDETERMINATION') {
      if (item.phasingProgramAttachmentId) {
        var attachementIds = item.phasingProgramAttachmentId.split(',')
        if (attachementIds.length > 0) {
          images.push({
            url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
              this.props.user,
              this.props.proposal,
              attachementIds[0]
            ),
            caption: 'CCALL_CCWEAK',
          })
          images.push({
            url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
              this.props.user,
              this.props.proposal,
              attachementIds[1]
            ),
            caption: 'OCCUPANCY_SITENUMBER',
          })
        }
      }
    }

    if (PhasingStep_phasingStepType.toUpperCase() === 'PHASING') {
      images.push({
        url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
          this.props.user,
          this.props.proposal,
          item.phasingProgramAttachmentId
        ),
        caption: '',
      })
    }

    if (PhasingStep_phasingStepType.toUpperCase() === 'MODELBUILDING') {
      metadata['Solvent Content'] = item.PhasingStep_solventContent

      if (item.png) {
        var phasingStepPngs = item.png.split(',')
        var fileTypes = item.fileType.split(',')

        for (var z = 0; z < fileTypes.length; z++) {
          if (fileTypes[z] === 'IMAGE') {
            if (phasingStepPngs[z]) {
              images.push({
                url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
                  this.props.user,
                  this.props.proposal,
                  phasingStepPngs[z]
                ),
                caption: 'PDB ' + phasingStepPngs[z],
              })
            }
          } else {
            imagesAttachedToPreviousStep.push({
              url: getPhasingFilesByPhasingProgramAttachmentIdAsImage(
                this.props.user,
                this.props.proposal,
                phasingStepPngs[z]
              ),
              caption: '',
            })
          }
        }
      }
      if (item.map) {
        var mapsArr = item.map.split(',')
        if (mapsArr.length === 2) {
          var mapUrl1 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[0])
          var mapUrl2 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[1])
          var pdb = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, item.pdb)
          electronViewer = getElectronViewer(pdb, mapUrl1, mapUrl2)
        }
      }
    }

    return [
      {
        step: item,
        metadata: metadata,
        images: images,
        imagesAttachedToPreviousStep: imagesAttachedToPreviousStep,
        stepsInline: this.getStepsInline(item, []),
        electronViewer: electronViewer,
      },
    ]
  }

  getStepsInline(item, stepsInline) {
    if (item.next) {
      if (item.next.length === 1) {
        stepsInline.push(this.getDataFromStep(item.next[0]))
        stepsInline.push(this.getStepsInline(item.next[0]))
      }
    }
    return stepsInline
  }

  getInlineSteps(stepRow) {
    var steps = [stepRow]
    if (stepRow.stepsInline) {
      stepRow.stepsInline.map(item => {
        if (item) {
          steps.push(item[0])
        }
      })
    }
    return steps
  }

  renderMenuItems = (items, visitedStepIds) =>
    items.map(item => {
      var stepsInline = this.getInlineSteps(this.getDataFromStep(item)[0])

      stepsInline = filter(stepsInline, function (s) {
        return !visitedStepIds.includes(s.metadata.stepId)
      })
      visitedStepIds = visitedStepIds.concat(
        stepsInline.map(function (e) {
          return e.metadata.stepId
        })
      )

      var panel = (
        <>
          <PhasingMetadataPanel stepsRow={stepsInline} user={this.props.user} proposal={this.props.proposal} />
          {item.children && item.children.length > 0 && this.renderMenuItems(item.children, visitedStepIds)}
        </>
      )
      return panel
    })

  render() {
    return this.props.data.map(element => this.renderMenuItems([element], []))
  }
}

class PhasingMetadataPanel extends Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  getMetadataTable(steps, user, proposal) {
    function getStatsByStep(stepType) {
      var stats = []
      var found = getStepByType(stepType)
      if (found) {
        if (found.step) {
          let name = found.step.metric.split(',')
          let value = found.step.statisticsValue.split(',')
          for (let i = 0; i < name.length; i++) {
            stats.push({ name: name[i], value: convertToFixed(value[i], 2) })
          }
        }
      }
      return stats
    }

    function getImagesByStep(stepType) {
      var step = getStepByType(stepType)
      if (step) {
        return step.images
      }
      return []
    }

    function getStepByType(stepType) {
      return find(steps, function (s) {
        return stepType.includes(s.metadata.Step)
      })
    }

    function hasStepTypes(stepTypesParam) {
      var steptypes = stepTypesParam.split(' ')
      for (let i = 0; i < steptypes.length; i++) {
        if (!getStepByType(steptypes[i])) {
          return false
        }
      }
      return true
    }
    function getImages(stepTypesParam, index) {
      var img = []
      var steptypes = stepTypesParam.split(' ')
      steptypes.forEach(stepType => {
        var images = getImagesByStep(stepType)
        for (let i = 0; i < images.length; i++) {
          const image = images[i]
          if (image.url.indexOf('null') === -1) {
            img.push(
              <td>
                <ImageZoom
                  image={{
                    src: image.url,
                    alt: image.caption,
                    style: { display: 'block', maxWidth: '150px', height: 'auto', margin: 'auto' },
                  }}
                  zoomImage={{
                    src: image.url,
                    alt: image.caption,
                  }}
                />
              </td>
            )
          }
        }
      })
      if (index) {
        if (img[index]) {
          return img[index]
        }
        return null
      }
      return img
    }

    function getHeaderStep(stepType) {
      var found = getStepByType(stepType)
      if (found !== null) {
        return (
          <>
            <h5>
              <span style={{ whiteSpace: 'nowrap' }}>
                <Glyphicon glyph="arrow-right" /> {found.metadata.Step}
              </span>
            </h5>
            <Label>{found.metadata.Program} </Label>
            <br />
            <a
              style={{ fontSize: '10px' }}
              href={getDownloadFilesByPhasingStepIdURL(user, proposal, found.step.PhasingStep_phasingStepId)}
            >
              <Glyphicon glyph="download" /> Download
            </a>
            <br />
            {found.electronViewer && (
              <a style={{ fontSize: '10px' }} target="_blank" rel="noreferrer" href={found.electronViewer}>
                <Glyphicon glyph="eye-open" /> UglyMol
              </a>
            )}
          </>
        )
      }
      return null
    }

    if (hasStepTypes('PREPARE')) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12} md={1}>
              {getHeaderStep('PREPARE')}
            </Col>
            <Col xs={12} md={1}>
              <Table>
                <tbody>
                  <tr>{getImages('PREPARE')}</tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      )
    }
    if (hasStepTypes('SUBSTRUCTUREDETERMINATION')) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12} md={1} />
            <Col xs={12} md={2}>
              {getHeaderStep('SUBSTRUCTUREDETERMINATION')}
            </Col>
            <Col xs={12} md={1}>
              <Table>
                <tbody>
                  <tr>{getImages('SUBSTRUCTUREDETERMINATION')}</tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      )
    }

    if (hasStepTypes('PHASING')) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12} md={2} />
            <Col xs={12} md={1}>
              {getHeaderStep('PHASING')}
            </Col>
            <Col xs={12} md={1}>
              <Table>
                <tbody>
                  <tr>{getStatsByStep('PHASING').map(item => this.getRow(item.name, item.value))}</tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={12} md={1}>
              <Table>
                <tbody>
                  <tr>{getImages('PHASING')}</tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      )
    }

    if (hasStepTypes('MODELBUILDING')) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12} md={4} />
            <Col xs={12} md={1}>
              {getHeaderStep('MODELBUILDING')}
            </Col>
            <Col xs={12} md={2}>
              <Table>
                <tbody>
                  <tr>{getStatsByStep('MODELBUILDING').map(item => this.getRow(item.name, item.value))}</tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={12} md={1}>
              <Table>
                <tbody>
                  <tr>{getImages('MODELBUILDING')}</tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      )
    }
  }

  render() {
    var items = []
    if (this.props.stepsRow.length > 0) {
      for (let i = 0; i < this.props.stepsRow.length; i++) {
        const element = this.props.stepsRow[i]
        if (this.props.stepsRow[i + 1]) {
          if (this.props.stepsRow[i + 1].imagesAttachedToPreviousStep) {
            this.props.stepsRow[i + 1].imagesAttachedToPreviousStep.forEach(image => {
              element.images.push(image)
            })
          }
        }
        items.push(this.getMetadataTable([element], this.props.user, this.props.proposal))
      }
    }
    return <>{items}</>
  }
}
